import { apiRequest } from "../api/client";
import { GenericDatabasePayload } from "../common/common.types";
import { CreateTableBatchResponse, CreateTargetResponse, GetRegisteredTargetParams, PhysicalTablesRequest, RegisteredDestinationsResponse, TargetTablesBatchBody } from "./destination.types";

const destinationService = {
    getRegisteredDestinations: async (params?: GetRegisteredTargetParams): Promise<RegisteredDestinationsResponse> => {
        const queryParams: Record<string, string | number> = {};

        if (typeof params?.limit === 'number') {
            queryParams.limit = params.limit;
        }

        if (typeof params?.page === 'number') {
            queryParams.page = params.page;

        }
        if (params?.allowed_instances?.trim()) {
            queryParams.allowed_instances = params.allowed_instances.trim();
        }
        if (params?.target_name?.trim()) {
            queryParams.target_name = params.target_name.trim();
        }
        return apiRequest<RegisteredDestinationsResponse>({
            method: 'GET',
            url: '/target-data-sources/registered',
            params: queryParams,
        }, 'Failed to fetch registered target data sources');
    },

    createTargetDataSource: async (params: GenericDatabasePayload): Promise<CreateTargetResponse> => {
        return apiRequest<CreateTargetResponse>({
            method: 'POST',
            url: '/target-data-sources',
            data: params,
        }, 'Failed to create target data source');
    },

    createPhysicalTable: async (
        params: PhysicalTablesRequest
    ): Promise<{ rows: unknown[] }> => {
        return apiRequest<{ rows: unknown[] }>(
            {
                method: 'POST',
                url: '/physical-tables',
                data: params,
            },
            'Failed to create physical table'
        );
    },

    createTargetTableBatch: async (
        params: TargetTablesBatchBody
    ): Promise<CreateTableBatchResponse> => {
        return apiRequest<CreateTableBatchResponse>(
            {
                method: 'POST',
                url: '/target-tables/batch',
                data: params,
            },
            'Failed to create target table batch'
        );
    },
}

export default destinationService;